/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { HealthFindrStrictHttpResponse } from '../../health-findr-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CommunicationTemplateModel } from '../../models/communication-template-model';

export interface CommunicationTemplateIdGet$Params {
  id: string;
}

export function communicationTemplateIdGet(http: HttpClient, rootUrl: string, params: CommunicationTemplateIdGet$Params, context?: HttpContext): Observable<HealthFindrStrictHttpResponse<CommunicationTemplateModel>> {
  const rb = new RequestBuilder(rootUrl, communicationTemplateIdGet.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as HealthFindrStrictHttpResponse<CommunicationTemplateModel>;
    })
  );
}

communicationTemplateIdGet.PATH = '/CommunicationTemplate/{id}';
